/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';

import { useArgs } from 'solis/navigation';

import ActionFooter from 'solis/claude/action/footer';
import Validation from 'solis/claude/action/validation';


export default ({ label, descriptor, context, commit, onSuccess, children }) =>
{
  const raw = useArgs(Object.keys(descriptor.inputs), descriptor.scope);

  if (!descriptor.isAvailable(context))
  {
    return null;
  }

  const args = Object.fromEntries(Object.entries(descriptor.inputs).map(([ name, fallback ]) =>
  {
    return [ name, raw[name] ?? fallback ];
  }));

  context = { ...context, args };

  const payload = descriptor.buildArgs(context);
  const result  = descriptor.validate(context);

  return (
    <Card>
      <Flex direction = 'column' gap = '3'>

        <Text.Label>{label}</Text.Label>

        <Validation value = {result}>
          {children}
        </Validation>

        <ActionFooter type = {descriptor.type} args = {payload} valid = {result.valid} issues = {result.issues} label = {commit} onSuccess = {onSuccess} />

      </Flex>
    </Card>
  );
};
